import React, { FunctionComponent } from 'react';

interface ArrowBubbleErrorProps {
  // message what will be displayed inside the bubble.  If this is not provided (or is null/undefined), then the
  // component will not render anything.
  message?: string;
}

// ArrowBubbleError displays with red "bubble" box with an arrow pointing up (presumably at the field that is causing
// the error), with the message is displayed (e.g. "this field is required").
export const ArrowBubbleError: FunctionComponent<ArrowBubbleErrorProps> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <div className="flex">
      <div className="mt-1">
        {/* NOTE: the div below is styled to be an arrow pointing up */}
        <div className="ml-8 h-0 w-0 border border-b-8 border-l-8 border-r-8 border-widget border-b-destructive" />
        <div className="rounded-md bg-destructive px-4 py-3 text-on-destructive outline-0 ring-0">{message}</div>
      </div>
    </div>
  );
};
